/* eslint-disable react/no-danger */
import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Div = styled.div`
  text-align: center;
  h2 {
    font-size: 18px;
    font-weight: bold;
    width: 80%;
    margin: 0 auto 20px;
  }
  p {
    font-size: 14px;
    width: 90%;
    margin: 0 auto;
  }
  a {
    cursor: pointer;
    width: 300px;
    height: 45px;
    color: #000;
    background-color: #facd22;
    margin: 20px auto 30px;
    text-align: center;
    display: block;
    position: relative;
    border: none;
    box-shadow: none;
    border-radius: 2px;
    font-size: 16px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    text-decoration: none;
  }
  p {
    &.legal {
      font-size: 11px;
      color: #9b9b9b;
      margin-top: 120px;
      margin-bottom: 0;
      width: 75%;
    }
  }
`;

export default class Thanks extends Component {
  componentDidMount() {
    var axel = Math.random() + "";
    var a = axel * 10000000000000;
    document.write(
      '<img src="https://ad.doubleclick.net/ddm/activity/src=6995216;type=crm;cat=5-her0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=' +
        a +
        '?" width="1" height="1" alt=""/>'
    );
    window.gtag('event', 'conversion', {
          'allow_custom_scripts': true,
          'send_to': 'DC-11775911/otherp/hertz0+standard'
      });
  }
  render() {
    const { copy } = this.props;
    return (
      <Div>
        <h2>{copy.thanks.title}</h2>
        <a target="_self" href={copy.thanks.action_link}>
          {copy.thanks.action}
        </a>
        <p className="legal">{copy.thanks.subtitle}</p>
      </Div>
    );
  }
}

Thanks.defaultProps = {};

Thanks.propTypes = {
  copy: PropTypes.objectOf(PropTypes.object).isRequired
};
